import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NumberWheelGuardService {
  init(): void {
    if (typeof document === 'undefined') return;

    document.addEventListener(
      'wheel',
      (e: WheelEvent) => {
        const target = e.target as HTMLElement | null;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.type !== 'number') return;
        if (document.activeElement !== target) return;
        e.preventDefault();
      },
      { capture: true, passive: false }
    );
  }
}
